export default "__VITE_ASSET__BaUhYkPQ__"